<script>
  import { createNamespacedHelpers } from 'vuex';

  const { mapGetters } = createNamespacedHelpers('plate');

  export default {
    name: 'CustomOptions',
    props: {
      variant: {
        /** The currently selected frame variant */
        type: Object,
        required: true,
      },
      letterStyle: {
        /** The currently selected letter style */
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapGetters([
        'getBaseProducts',
        'getLetterStyles',
        'getSelectedBaseProduct'
      ]),
    },
    methods: {
      getStates(frameStates) {
        let states = '';
        frameStates.forEach((state, i) => {
            states += i < frameStates.length - 1 ? state.label + ',' : state.label;
        });
        return states;
      },
      selectBase() {
        /**
         * this will be for products that have multiple frames
         * with same implementation as below
         */
      },
      selectVariant(index) {
        /**
         * this will follow same implementation of selectLetterStyle
         * for variants
         */
        this.$store.dispatch('plate/selectBaseVariant', index);
      },
      selectLetterStyle(style) {
        this.$store.dispatch('plate/selectLetterStyle', {
          index: 0,
          selected: style,
        });
      },
    },
  };
</script>

<template>
  <div class="letter-edit x-type--wrap">

    <div class="letter-edit__wrap">

      <div v-if="getBaseProducts.length > 1" class="letter-edit__colors js-custom-plate__frame-types">
        <label class="letter-edit__label">
          Type: <span class="js-custom-plate__frame-type-label">{{ getSelectedBaseProduct.name }}</span>
        </label>

        <div v-for="type in getBaseProducts" :key="type.id" class="letter-edit__color m-frame">
          <input
            type="radio"
            class="js-custom-plate__frame-type-radio"
            name="frame-type"
            :checked="getSelectedBaseProduct.id === type.id"
            @click="selectBase(type)"
            :id="'frame_' + type.id"
            :value="type.id"
          />
          <label
            :for="'base_' + type.id"
            :title="getStates(type.states)"
            :style="{ backgroundImage: 'url(' + type.image + ')' }"
          >
            <span></span>
            {{ type.name }}
          </label>
        </div>
      </div>

      <div class="letter-edit__colors js-custom-plate__frame-colors">
        <label class="letter-edit__label">
          License Plate Color: <span class="js-custom-plate__frame-colors-label">{{ variant.finish.label }}</span>
        </label>

        <div
          v-for="(style, index) in getSelectedBaseProduct.variants"
          :key="style.id"
          :class="'letter-edit__color m-swatch-' + style.finish.brightness"
        >
          <input
            type="radio"
            name="frame-color"
            @click="selectVariant(index)"
            :id="'color_' + style.finish.id"
            :checked="variant.id === style.id"
            :value="style.finish.id"
          />
          <label :for="'color_' + style.finish.id" :style="{ backgroundImage: 'url(' + style.finish.swatch + ')',}">
            {{ style.finish.label }}
          </label>
        </div>
      </div>

      <div class="letter-edit__colors js-custom-plate__letter-styles">
        <label class="letter-edit__label">
          Letter Color: <span class="js-custom-plate__letters-styles-label">{{ letterStyle.finish.label }}</span>
        </label>

        <div
          v-for="style in getLetterStyles"
          :key="style.id"
          :class="'letter-edit__color m-swatch-' + style.finish.brightness"
        >
          <input
            type="radio"
            name="letter-style"
            @click="selectLetterStyle(style)"
            :checked="letterStyle.id === style.id"
            :id="'letter_style_' + style.id"
            :value="style.id"
          />
          <label :for="'letter_style_' + style.id" :style="{ backgroundImage: 'url(' + style.finish.swatch + ')',}">
            {{ style.finish.label }}
          </label>
        </div>
      </div>

    </div>
  </div>
</template>
